var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-1 overflow-auto p-6",attrs:{"data-testid":"co-living-ticket-page"}},[_c('PageHeader',{attrs:{"title":_vm.ticketId,"icon":"ticket","allow-back":"","back-url":{
      name: 'co_living_tickets',
      params: { accountId: _vm.$route.params.accountId },
    }}}),_vm._v(" "),_c('TicketDetail',{attrs:{"ticket-id":_vm.ticketId}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }